import React from 'react';
import { cn } from '@/utils';
import { useDialMove } from '@/hooks/useDialMove';
import EditorDialBg from './assets/editor-dial-bg.png';

export interface DialProps {
  onChange?: (val: number) => void;
  initValue?: number;
  disabled?: boolean;
}

const EditorDial: React.FC<DialProps> = ({ onChange, initValue, disabled }) => {
  const initClipDegree = 60;
  const fullDegree = 360 - initClipDegree * 2;
  const { value, startDragging, dialRef } = useDialMove({
    onChange,
    initValue,
    initClipDegree,
  });

  const handleMouseDown = (e: React.MouseEvent) => {
    startDragging();
    e.preventDefault();
  };

  return (
    <div className={`flex flex-col items-center w-full h-full ${disabled ? 'cursor-not-allowed' : ''}`}>
      <div
        ref={dialRef}
        className={`relative w-[60px] h-[60px] box-content rounded-full border-[5px] ${disabled ? 'border-gray-400' : 'border-[#111112]'} ${disabled ? 'bg-gray-300' : ''}`}
        onMouseDown={disabled ? undefined : handleMouseDown}
      >
        <div
          className={cn('absolute inset-0 bg-[#343638] rounded-full transition-transform duration-300')}
          style={{
            transform: `rotate(${value * 3.6 - fullDegree}deg)`,
            background: `url(${EditorDialBg}) no-repeat`,
            backgroundSize: 'cover',
          }}
        />
        <div
          className="absolute bg-jen-content-primary w-[5px] h-[5px] rounded-full"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: `translate(-50%, -50%) rotate(${value * fullDegree - (90 - initClipDegree)}deg) translateX(-12px)`,
            transformOrigin: 'center',
          }}
        />
        {new Array(9).fill(0).map((_, index) => {
          return (
            <div
              key={index}
              className={cn('absolute bg-jen-content-tertiary w-[3px] h-[3px] rounded-full', {
                'bg-jen-content-primary': value * fullDegree < (index / 8) * fullDegree,
                'bg-jen-interactive-primary':
                  value * fullDegree >= (index / 8) * fullDegree && value * fullDegree < ((index + 1) / 8) * fullDegree,
              })}
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: `translate(-50%, -50%) rotate(${(index / 8) * fullDegree - (90 - initClipDegree)}deg) translateX(-26px)`,
                transformOrigin: 'center',
              }}
            />
          );
        })}
      </div>
      <div className="absolute inset-0 flex items-center justify-center text-white text-4xl font-bold">{/* {value} */}</div>
    </div>
  );
};

export default EditorDial;
